import en from './language-en.json';

export { en };
